import { create } from "zustand";

interface WalkthroughModalState {
  showWalkthroughModal: boolean;
  setShowWalkthroughModal: (show: boolean) => void;
}

export const useWalkthroughModalStore = create<WalkthroughModalState>(
  (set) => ({
    showWalkthroughModal: false,
    setShowWalkthroughModal: (show: boolean) => set({ showWalkthroughModal: show }),
  })
);
